/**
 * trend-pullback-page.js
 *
 * Trend Pullback strategy — across Weekly, Daily, 4H:
 *   Long:  9 EMA > 20 SMA · both sloping up · price touches or below 9 EMA
 *   Short: 9 EMA < 20 SMA · both sloping down · price touches or above 9 EMA
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchTrendPullbackData } from '../services/server-api';

const TF_LABELS = { weekly: 'Weekly', daily: 'Daily', fourHour: '4H' };

function slopeLabel(slope) {
  if (slope === 'up')   return '↑ rising';
  if (slope === 'down') return '↓ falling';
  return '→ flat';
}

function renderDetails(entry) {
  const ema9Val  = entry.ema9  != null ? `$${entry.ema9.toLocaleString(undefined,  { maximumFractionDigits: 4 })}` : '—';
  const sma20Val = entry.sma20 != null ? `$${entry.sma20.toLocaleString(undefined, { maximumFractionDigits: 4 })}` : '—';
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">9 EMA</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>
          {ema9Val} {slopeLabel(entry.ema9Slope)}
        </span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">20 SMA</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>
          {sma20Val} {slopeLabel(entry.sma20Slope)}
        </span>
      </div>
    </>
  );
}

function TrendPullbackPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'Trend Pullback',
        icon:       '🎯',
        subtitle:   '9 EMA > 20 SMA (long) / < 20 SMA (short) · both slopes agree · price touches or crosses the 9 EMA',
        fetchFn:    fetchTrendPullbackData,
        timeframes: ['weekly', 'daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default TrendPullbackPage;
